import React from "react";
import { Link, useLocation } from 'react-router-dom';
import Icons from '../myIcon/Icons';

export default function Footer({ footerHide }) {
  const location = useLocation();

  // location value
  const locationData = {
    "resort-de-coracao-goa": {
      image: "/image/footer-goa.webp",
    },

    "resort-de-coracao-rishikesh": {
      image: "/image/footer-rishikesh.webp",
    },

    "resort-de-coracao-corbett": {
      image: "/image/footer-corbett.webp",
    }
  };

  // Default value
  const defaultData = {
    image: "/image/footer-image.webp",
  };

  // slug detect
  const currentSlug = Object.keys(locationData).find(slug =>
    location.pathname.includes(slug)
  );

  const currentData = locationData[currentSlug] || defaultData;

  return (
    <>
      <footer className={`footer-area ${footerHide || ''}`}>
        <div className="big-container">
          <div className="row">
            <div className="col-12 col-lg-3 col-md-4">
              <div className="footer-location">
                <img src='/image/footer-location-icon.webp' alt='location' />
                <div>
                  <span>Goa -</span> <a href='https://maps.app.goo.gl/zRe8HjaScCxQmW7h7' target="_blank" rel="noreferrer" className="line-button">View on map</a>
                  <p>120/5 Gaura Vaddo Calangute, Goa- 403516</p>
                  <small>by Ria Hospitality Pvt. Ltd.</small>
                </div>
              </div>

               <div className="footer-location">
                <img src='/image/footer-location-icon.webp' alt='location' />
                <div>
                  <span>Corbett -</span> <a href='https://maps.app.goo.gl/SM15UMhx2jkoRGRq8' target="_blank" rel="noreferrer" className="line-button">View on map</a>
                  <p>Khasra No- 67 Savalde west Dhela Road Ramnagar, Nainital Uttarakhand -244715 (India)</p>
                  <small>by Ria Vacations Pvt. Ltd.</small>
                </div>
              </div>
              
              <div className="footer-location">
                <img src='/image/footer-location-icon.webp' alt='location' />
                <div>
                  <span>Rishikesh -</span> <a href='https://maps.app.goo.gl/zVrkTzPMoZxZ5SBf6' target="_blank" rel="noreferrer" className="line-button">View on map</a>
                  <p>Laxman Jhula Road Tapovan Rishikesh 249137 Uttarakhand</p>
                  <small>-by Ria Vacations Pvt. Ltd.</small>
                </div>
              </div>

             
              <Link to="/contact-us" className="line-button arrival-link">Plan Your Arrival</Link>
            </div>

            <div className="col-12 col-lg-6 col-md-4">
              <div className="footer-midarea">
                <h4 className="footer-tagline heading">Feel Good, Enjoy Your Stay</h4>

                <div>
                  <div className="footer-contact">
                    <a href="tel:+91 9292928787" className="footer-phone">+91 929292 8787</a>
                    <a href="mailto:reservation@resortdecoracao.com">reservation@resortdecoracao.com</a>
                  </div>

                  <ul className="footer-social">
                    <li><Link to="https://www.facebook.com/ResortDeCoracaoofficial/" target="_blank" aria-label="Facebook"><Icons name="facebook" /></Link></li>
                    <li><Link to="https://www.instagram.com/resortdecoracao/" target="_blank" aria-label="instagram"><Icons name="instagram" /></Link></li>
                    <li><Link to="https://www.linkedin.com/company/resort-de-coração" target="_blank" aria-label="linkedin"><Icons name="linkedin" /></Link></li>
                    <li><Link to="https://web.whatsapp.com/send?phone=+919292928787&_ga=2.261651789.1393896926.1665567039-1858394251.1662704687" target="_blank" aria-label="whatsapp"><Icons name="whatsapp" /></Link></li>
                    <li><Link to="https://www.youtube.com/channel/UCjgc3pXH7KYjPdsDCKnD_vw" target="_blank" aria-label="youtube"><Icons name="youtube" /></Link></li>
                  </ul>

                  <div className="footer-links">
                    <Link to="/faqs">FAQ</Link>&bull;
                    <Link to="/terms">Privacy POlicy</Link>&bull;
                    <Link to="/terms">T&C</Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-3 col-md-4">
              <div className="footer-image">
                <img src={currentData.image} className='img-responsive' alt="Resort De Coracao" />
              </div>
            </div>

          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="footer-bottom">
                <p><span>Resort De Coração © 2026.</span> All Rights Reserved.</p>
                <p>Designed by <a href="https://www.88gravity.com" target="_blank" rel="noopener noreferrer">88gravity</a></p>
              </div>
            </div>
          </div>
        </div>

        <a href="https://api.whatsapp.com/send?phone=9292928787" target="_blank" aria-label="Message Us on Whatsapp" className="float-whatsapp" rel="noreferrer"><img src="/image/whatsapp.webp" alt="whatsapp" /></a>
      </footer>
    </>
  );
}
